module.exports = __webpack_public_path__ + "assets/img/6.3025d209.jpg";